import { Loader, Modal } from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { StripeCardForm } from 'src/components/stripe-card-form';
import { useChangeSubscriptionPaymentMethod } from 'src/hooks/subscriptions/change-subscription-payment-method.hook';
import { useGetCurrentSubscription } from 'src/hooks/subscriptions/get-current-subscription.hook';

const AddBankCard = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation('settings');

  const { loading, updatePaymentMethod } = useChangeSubscriptionPaymentMethod({
    onSuccess: onClose,
  });

  const {
    subscription: { stripeSubscriptionId },
  } = useGetCurrentSubscription();

  return (
    <Modal isOpened onClose={onClose} title={t('settings:userProfileSettings.labels.changeCard')}>
      <div style={{ position: 'relative' }}>
        {loading && <Loader position="absolute" />}
        <StripeCardForm
          onClose={onClose}
          onFinish={paymentMethodId =>
            updatePaymentMethod({ paymentMethodId, stripeSubscriptionId })
          }
        />
      </div>
    </Modal>
  );
};

export default AddBankCard;
